import { create } from "zustand";

const useClaimStore = create((set, get) => ({
  claimData: [],

  setClaimData: ({ data, id }) => {
    set((state) => {
      const existingIndex = state.claimData.findIndex(
        (item) => Object.keys(item)[0] === id.toString()
      );

      const newClaimObject = {
        [id]: {
          sub_tickets: {
            id: data.sub_tickets?.id || 0,
            claim_amount: data.sub_tickets?.claim_amount || 0,
            claim_file_urls: data.sub_tickets?.claim_file_urls || [],
          },
        },
      };

      if (existingIndex === -1) {
        return {
          claimData: [...state.claimData, newClaimObject],
        };
      }

      const updatedClaimData = [...state.claimData];
      updatedClaimData[existingIndex] = newClaimObject;

      return { claimData: updatedClaimData };
    });
  },

  getClaimById: (id) => {
    const state = get();
    const claim = state.claimData.find(
      (item) => Object.keys(item)[0] === id.toString()
    );
    return claim ? claim[id] : null;
  },

  areReadyToSubmit: (ticketDataArray) => {
    const state = get();
    return ticketDataArray.every((ticket) =>
      state.claimData.some(
        (item) => Object.keys(item)[0] === ticket.id.toString()
      )
    );
  },
}));

export default useClaimStore;
